import React from 'react';
import Table from 'react-bootstrap/Table';

class OasisPoolNav extends React.Component {
  render() {
    let poolId = this.props.poolId;
    if (!poolId) {
      poolId = this.props.poolId;
    }

    return (
      <div width="90%">
        <hr/>
        <p><b>Performance tools</b></p>
        <Table striped bordered hover variant="dark" >
          <thead>
            <tr>
              <th><a className="white-a" href="/">All Validators</a></th>
              <th><a className="white-a" href={"/pool/" + poolId}>Summary</a></th>
              <th><a className="white-a" href={"/poolStats/" + poolId}>Stats</a></th>
            </tr>
            <tr>
              <th><a className="white-a" href={"/events/" + poolId}>Events</a></th>
              <th><a className="white-a" href={"/delegates/" + poolId}>Delegates</a></th>
            </tr>
          </thead>
        </Table>
      </div>
    );
  }
}

export default OasisPoolNav;



// WEBPACK FOOTER //
// ./src/oasis/OasisPoolNav.js